// extracted by mini-css-extract-plugin
export default {"container":"proof-requested_container__g4Wj5","greenButton":"proof-requested_greenButton__3hFxT"};